import { render, staticRenderFns } from "./ProgramProductSynthesis.vue?vue&type=template&id=080997c2&scoped=true&"
import script from "./ProgramProductSynthesis.vue?vue&type=script&lang=js&"
export * from "./ProgramProductSynthesis.vue?vue&type=script&lang=js&"
import style0 from "./ProgramProductSynthesis.vue?vue&type=style&index=0&id=080997c2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080997c2",
  null
  
)

export default component.exports